"use strict";

var _classCallCheck = require("/var/nobackup/jenkins/jobs/DDI Frontend/branches/release-2022-04.94hkrn/workspace/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/var/nobackup/jenkins/jobs/DDI Frontend/branches/release-2022-04.94hkrn/workspace/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

var _possibleConstructorReturn = require("/var/nobackup/jenkins/jobs/DDI Frontend/branches/release-2022-04.94hkrn/workspace/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _get = require("/var/nobackup/jenkins/jobs/DDI Frontend/branches/release-2022-04.94hkrn/workspace/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/get");

var _getPrototypeOf = require("/var/nobackup/jenkins/jobs/DDI Frontend/branches/release-2022-04.94hkrn/workspace/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/var/nobackup/jenkins/jobs/DDI Frontend/branches/release-2022-04.94hkrn/workspace/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ToolbarSelectIcon = void 0;

var ToolbarIcon_1 = require("./ToolbarIcon");

var ToolbarSelectIcon = /*#__PURE__*/function (_ToolbarIcon_1$Toolba) {
  _inherits(ToolbarSelectIcon, _ToolbarIcon_1$Toolba);

  function ToolbarSelectIcon(paper, icon, onAction) {
    var _this;

    _classCallCheck(this, ToolbarSelectIcon);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(ToolbarSelectIcon).call(this, paper, icon));
    _this.onAction = onAction;

    _this.buildIconUI();

    return _this;
  }

  _createClass(ToolbarSelectIcon, [{
    key: "activate",
    value: function activate() {
      this.onAction(this.description.action);
      this.select();
    }
  }, {
    key: "move",
    value: function move(x, y) {
      _get(_getPrototypeOf(ToolbarSelectIcon.prototype), "move", this).call(this, x, y);

      this.iconBackgrounRect.attr({
        x: x,
        y: y
      });

      if (this.iconImageSVG !== undefined) {
        this.iconImageSVG.attr({
          x: x,
          y: y
        });
      }
    }
  }, {
    key: "resize",
    value: function resize(width, height) {
      _get(_getPrototypeOf(ToolbarSelectIcon.prototype), "resize", this).call(this, width, height);

      this.iconBackgrounRect.attr({
        height: this.height,
        width: this.width
      });
      this.iconImageSVG.attr({
        height: this.height,
        width: this.width
      });
    }
  }, {
    key: "buildIconUI",
    value: function buildIconUI() {
      var _this2 = this;

      this.node = this.paper.g();
      this.node.addClass("iconStyle");
      this.node.addClass("selector");
      this.iconBackgrounRect = this.paper.rect(0, 0, this.width, this.height);
      this.iconBackgrounRect.addClass("iconBGRectStyle");
      this.iconImage = this.paper.g();

      if (this.description.iconUrl !== undefined) {
        Snap.load(this.description.iconUrl, function (fragment) {
          _this2.iconImage.append(fragment);

          _this2.iconImageSVG = _this2.iconImage.children().find(function (element) {
            return element.type === "svg";
          });

          if (_this2.iconImageSVG !== undefined) {
            _this2.iconImageSVG.attr({
              height: _this2.height,
              width: _this2.width
            });

            _this2.move(_this2.x, _this2.y);
          }
        });
      }

      this.iconImage.addClass("iconImageStyle");
      var title = Snap.parse("<title>".concat(this.description.tooltip, "</title>"));
      this.node.add(this.iconBackgrounRect);
      this.node.add(this.iconImage);
      this.node.append(title);
      this.node.click(function (e) {
        _this2.activate();
      });
    }
  }]);

  return ToolbarSelectIcon;
}(ToolbarIcon_1.ToolbarIcon);

exports.ToolbarSelectIcon = ToolbarSelectIcon;